module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-comment"
  }, [_c('img', {
    staticClass: "img-circle img-sm",
    attrs: {
      "src": _vm.profileImage,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-text"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("\n          " + _vm._s(_vm.name) + "\n          "), _c('span', {
    staticClass: "text-muted pull-right"
  }, [_vm._v(_vm._s(_vm.parseDate))])]), _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d3e2eea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VASocialBoxComment.vue
// module id = 533
// module chunks = 1